/**
 * Stat — large display number with a small caption underneath. Used in
 * dark/navy contexts (stats strips, hero stats).
 */
export default function Stat({ value, label, color = 'var(--yellow)' }) {
  return (
    <div>
      <div className="font-serif" style={{ fontSize: 56, fontWeight: 600, color, lineHeight: 1, letterSpacing: '-0.02em' }}>
        {value}
      </div>
      <div className="mt-1.5" style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', letterSpacing: '0.04em' }}>
        {label}
      </div>
    </div>
  );
}
